import { render } from "./Plugin.vue?vue&type=template&id=6c1ded16&scoped=true&ts=true"
import script from "./Plugin.vue?vue&type=script&lang=ts"
export * from "./Plugin.vue?vue&type=script&lang=ts"

import "./Plugin.vue?vue&type=style&index=0&id=6c1ded16&scoped=true&lang=css"

import exportComponent from "E:\\SLG\\ECO GAME\\Eco\\Server\\WebClient\\Sources\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1ded16"]])

export default __exports__